import { environment } from '@/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { City, CityCreateParams, CityFindAllParams } from '../core/type';
import { PaginatedResponse } from '@/app/common/utils/pagination/types';
import { CityService } from '../core/service';
import { User } from '../../user/core/type';

@Injectable()
export class CityApiService implements CityService {
  private readonly defaultUrl = `${environment.apiHost}/citys`;

  constructor(private httpClient: HttpClient) {}

  update(id: number, data: Omit<City, 'id'>): Observable<void> {
    return this.httpClient.patch<void>(`${this.defaultUrl}/${id}`, data);
  }

  getById(id: number): Observable<City> {
    return this.httpClient.get<City>(`${this.defaultUrl}/${id}`);
  }

  findAll(
    filter?: CityFindAllParams | undefined
  ): Observable<PaginatedResponse<City>> {
    return this.httpClient.get<PaginatedResponse<City>>(this.defaultUrl, {
      params: { ...filter },
    });
  }

  create(data: Omit<CityCreateParams, 'id'>) {
    return this.httpClient.post<void>(this.defaultUrl, data);
  }

  delete(id: number): Observable<void> {
    throw new Error('Method not implemented.');
  }
}
